import { render, staticRenderFns } from "./IntakeBatchSummary.vue?vue&type=template&id=b9ef5ec2"
import script from "./IntakeBatchSummary.vue?vue&type=script&lang=ts"
export * from "./IntakeBatchSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports